// Contrail V3.5.1 — "choose a new password" state after a reset or invite CODE was verified.
// A verified code signs the person in; until they have saved a new password every page shows Set password.
// Kept in sessionStorage so a refresh doesn't skip it.
export type SetPwReason = "reset" | "invite";
const KEY = "fw.setpw";
const EV = "fw-setpw";

export function pendingSetPassword(): SetPwReason | null {
  try { const v = sessionStorage.getItem(KEY); return v === "reset" || v === "invite" ? v : null; } catch { return null; }
}
export function startSetPassword(reason: SetPwReason) {
  try { sessionStorage.setItem(KEY, reason); } catch { /* ignore */ }
  window.dispatchEvent(new Event(EV));
}
export function endSetPassword() {
  try { sessionStorage.removeItem(KEY); } catch { /* ignore */ }
  window.dispatchEvent(new Event(EV));
}
export function onSetPasswordChange(fn: () => void) {
  window.addEventListener(EV, fn);
  return () => window.removeEventListener(EV, fn);
}
